//= React components
// Own
import { Statistic } from './components/Statistic';

export { Statistic };

export default {
    Statistic,
};
